const defaultProps = {
  variant: 'outlined',
  size: 'medium',
  disableElevation: true,
};

export default defaultProps;
